document.addEventListener("DOMContentLoaded", function () {
  const collapsibleButtons = document.querySelectorAll(
    ".collapsible__button-custom"
  );

  collapsibleButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const collapsibleId = this.getAttribute("data-collapsible-id");

      const content = document.querySelector(
        `.collapsible_content[data-collapsible-id="${collapsibleId}"]`
      );
      const icon = document.querySelector(
        `.plus_icon-custom[data-collapsible-id="${collapsibleId}"]`
      );

      this.classList.toggle("active");
      content.classList.toggle("active");
      icon.classList.toggle("active");
    });
  });

  const textReferences = document.querySelectorAll(".text_reference");
  const textReferenceMains = document.querySelectorAll(".text_reference-main");

  textReferences.forEach((reference) => {
    reference.addEventListener("click", function () {
      const textId = this.getAttribute("data-text-id");
      const targetMain = document.querySelector(
        `.text_reference-main[data-text-id="${textId}"]`
      );

      textReferences.forEach((ref) => ref.classList.remove("active"));

      this.classList.add("active");

      if (targetMain) {
        const targetPosition =
          targetMain.getBoundingClientRect().top + window.pageYOffset - 150;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  window.addEventListener("scroll", function () {
    if (textReferenceMains.length === 0) return;

    let activeIndex = -1;
    const scrollPosition = window.scrollY + 150;

    textReferenceMains.forEach((main, index) => {
      const rect = main.getBoundingClientRect();
      const offsetTop = rect.top + window.scrollY;

      if (offsetTop <= scrollPosition) {
        activeIndex = index;
      }
    });

    if (activeIndex >= 0) {
      textReferences.forEach((ref) => ref.classList.remove("active"));
      const activeRef = textReferences[activeIndex];
      if (activeRef) {
        activeRef.classList.add("active");
      }
    }
  });

  window.dispatchEvent(new Event("scroll"));
});
